<template>
  <div>
    <header style="display: flex; align-items: center; justify-content: space-between;">
      <h3>Formulários Dinâmicos</h3>
      <div>
        <SGPFormBotaoComponent
          class="text-capitalize mr-2"
          outlined
          :to="{name: 'ctrl-campos'}"
        >
          <SGPIconComponent>mdi-format-columns</SGPIconComponent>
          Gerenciar Campos
        </SGPFormBotaoComponent>
        <SGPFormBotaoComponent
          class="text-capitalize"
          :to="{name: 'ctrl-formularios-dinamicos-novo'}"
        >
          <SGPIconComponent>mdi-plus</SGPIconComponent>
          Novo Formulário
        </SGPFormBotaoComponent>
      </div>
    </header>

    <SGPTabelaComponent
      :colunas="colunas"
      :usuarioPodeExcluir="false"
      :usuarioPodeEditar="false"
      :dados="listaDeCtrlFormulariosDinamicos"
      filtroText
    >
      <template v-slot:item.acoes="{ item }">
        <div class="text-right">
          <SGPFormBotaoComponent
            text
            fab
            small
            @click="formularioPreview(item.id)"
            color="red"
            class="mr-3"
          >
            <SGPIconComponent>mdi-fit-to-screen-outline</SGPIconComponent> 
          </SGPFormBotaoComponent>
          <SGPFormBotaoComponent
            text
            fab
            small
            :to="{name: 'ctrl-formularios-dinamicos-edit', params: { id: item.id }}"
            @click="editContato(item)"
            color="red"
            class="mr-3"
          >
            <SGPIconComponent>mdi-pencil</SGPIconComponent>            
          </SGPFormBotaoComponent>
          <v-icon @click="deletar(item)" color="red">mdi-trash-can-outline</v-icon>
        </div>
      </template>
    </SGPTabelaComponent>

    <SGPConfirmacaoDelecaoComponent
      v-if="deletarDados"
      @sgpCancelarDelecaoEmit="cancelarDelecao()"
      @sgpConfirmarDelecaoEmit="confirmarDelecao()"
    />

    <SGPLoadingComponent v-if="loadingFormularioDinamico"></SGPLoadingComponent>

    <SGPModalComponent tamanho="lg"  v-if="mostrarModalVisualizacao" @sgpModalFechar="fecharModalVisualizacao">
      <!-- <RenderizaFormularioComponent :dadosExternos="dadosExternos" v-if="jsonVisualizacao" :json="jsonVisualizacao"></RenderizaFormularioComponent> -->
      <ModalRenderizaFormularioComponent v-if="formularioDinamico && formularioDinamico.length" :json="formularioDinamico[0]" :dadosExternos="dadosExternos" />
    </SGPModalComponent>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex/dist/vuex.common.js';

import ModalRenderizaFormularioComponent from '../components/ModalRenderizaFormularioComponent.vue'

export default {
  name: "CtrlFormularioDinamicoPage",
  components: {
    ModalRenderizaFormularioComponent
  },

  data () {
    return {
      formularioSelecionado: null,
      deletarDados: false,
      mostrarModalVisualizacao: false,
      dadosExternos: null
    }
  },

  async created () {
   await Promise.all([
     this.listarCampos(),
     this.listarFormulariosDinamicos()

   ])
  },

  computed: {
    ...mapGetters('ctrlFormularioDinamico', [
      'listaDeCtrlFormulariosDinamicos',
      'loadingFormularioDinamico',
      'formularioDinamico'
    ]),
    colunas () {
      return [
        {
          key: 'titulo',
          label: 'Formulário',
          sortable: false
        },
        {
          key: "acoes",
          label: '',
        }
      ]
    }
  },

  methods: {
    ...mapActions('ctrlCampos', [
      'listarCampos',
      'deletarCampo'
    ]),

    ...mapActions('ctrlFormularioDinamico', [
      'listarFormulariosDinamicos',
      'deletarFormularioDinamico',
      'recuperarFormularioDinamicoPorId'
    ]),

    deletar (item) {
      this.deletarDados = true
      this.formularioSelecionado = item
    },

    cancelarDelecao () {
      this.deletarDados = false
      this.formularioSelecionado = null
    },

    confirmarDelecao () {
      this.deletarFormularioDinamico(this.formularioSelecionado)
    },

    async formularioPreview (id) {
      await this.recuperarFormularioDinamicoPorId({ id: id})

      this.dadosExternos = await localStorage.getItem('form_dinamico_dado_externo')
      if (this.dadosExternos) {
        this.dadosExternos = JSON.parse(this.dadosExternos)
      }

      this.mostrarModalVisualizacao = !this.mostrarModalVisualizacao
    },

    fecharModalVisualizacao () {
      this.mostrarModalVisualizacao = !this.mostrarModalVisualizacao
      this.dadosExternos = null
    }
  }
}
</script>